module.exports = __webpack_public_path__ + "static/media/person9.27fb9e31.png";